export default defineNuxtPlugin(async () => {
  try {
    // Get scripts from site options using the composable
    const scriptsData = await useAcfOptions('scripts');

    let scripts = [];
    let noscripts = [];

    if (scriptsData && Array.isArray(scriptsData)) {
      scriptsData.forEach(item => {
        let obj = {};

        if (item.as_children === 'true' || item.as_children === true) {
          obj = {
            children: item.source,
            tagPosition: item.position
          }
        } else {
          const cleanedString = item.source
            .trim()
            .replace(/\r\n/g, "")
            .replace(/,\s*}/g, "}");

          try {
            const jsonObject = JSON.parse(cleanedString);
            obj = jsonObject;
          } catch (error) {
            console.error("JSON Parsing Error:", error.message);
            console.error("Problematic string:", cleanedString);
          }
        }

        if (item.type === 'script') {
          scripts.push(obj);
        } else if (item.type === 'noscript') {
          noscripts.push(obj);
        }
      });
    }

    // Apply the scripts and noscripts to the head
    if (scripts.length > 0 || noscripts.length > 0) {
      useHead({
        script: scripts,
        noscript: noscripts
      });
    }

  } catch (error) {
    console.warn('Failed to load tag scripts:', error);
  }
});